export const newrelicErrorHandler = (error: string | Error): void => {
  if (typeof newrelic !== 'undefined') {
    newrelic.noticeError(error)
  }
}

export const genericErrorLogger = async (
  errorSource: string,
  error: Error,
): Promise<void> => {
  if (typeof window === 'undefined') {
    const { logger } = await import('src/utils/Logger')
    logger.error(`Generic Server error from ${errorSource}: ${error.message}`)
  } else {
    window.newrelic?.noticeError(
      `Generic Client error from ${errorSource}: ${error.message}`,
    )
  }
}
